module.exports = __webpack_public_path__ + "media/images/pixel-3e38c82a4897312010eec8419881eec8.gif";